/**
 * moves items with name Other to the end of array if at least on of it's properties is not null
 * @param array - source array
 * @param properties array of properties
 * @returns result array
 */
const moveOtherToEnd = function (array, properties = ['value']) {
  array = [...array]
  const otherIndex = array.findIndex(item => item.name.toLowerCase() === 'other')
  if (otherIndex > -1) {
    const other = { ...array[otherIndex] }
    array.splice(otherIndex, 1)
    const someOtherPropsNotEmpty = properties.some(prop => other[prop] !== 0)
    if (someOtherPropsNotEmpty) {
      array.push(other)
    }
  }

  return array
}
/**
 * moves items with type 'Clients' to start
 * @param array - source array
 * @param arrayContainsCompanyType supporting array contains company types
 * @returns result array
 */
const moveClientToStart = function (array, arrayContainsCompanyType) {
  const sortedArray = [...array]
  let clientIndex
  // find company name with type Client
  if (arrayContainsCompanyType) {
    const clientCompany = arrayContainsCompanyType.find(item => item.type === 'Clients')
    if (!clientCompany) {
      return sortedArray
    }
    const name = clientCompany.label
    clientIndex = sortedArray.findIndex(item => item.name === name)
  } else {
    clientIndex = sortedArray.findIndex(item => item.type === 'Clients')
  }

  if (clientIndex > -1) {
    const client = { ...sortedArray[clientIndex] }
    sortedArray.splice(clientIndex, 1)
    sortedArray.unshift(client)
  }
  return sortedArray
}

export {
  moveOtherToEnd,
  moveClientToStart
}
